import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";

export default function AppointmentErrorModal({ setModalOpen, modalOpen }) {
  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between"
    >
      <div className="flex flex-col space-y-x-large py-4">
        <div className="flex justify-between">
          <div className="flex flex-col space-y-2 -mt-1">
            <h2 className="text-4xl font-semibold leading-none">
              Appointment Unavailable
            </h2>
          </div>
          <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
            <img src={CloseIcon} alt="" variant="secondary" />
          </div>
        </div>
        <p className="text-lg text-gray-700">
          Sorry, this appointment slot was just booked by someone else. Please
          select a new appointment time.
        </p>
      </div>
      <div className="flex justify-end mt-2">
        <Button onClick={() => setModalOpen(false)}>Ok</Button>
      </div>
    </Modal>
  );
}
